<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="currentIdTreasury" :confirm="askConfirm"
                    :title="$t('treasury.modify')"
                    route-back="TreasuryIndex"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('treasury.new')"
                    route-back="TreasuryIndex"/>
      </div>

      <b-card class="col-md-12 my-3">
        <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
          <div class="row">
            <div class="col-md-6">
              <b-form-group
                :invalid-feedback="form.date.invalidFeedback"
                :label="$t('chargePro.Date')"
                :state="form.date.state"
                class="medium-label mb-4"
                label-for="date-input">
                <month-picker-input
                  id="date-charge-input"
                  :clearable="true"
                  :no-default="true"
                  :default-month="defaultMonth"
                  :default-year="defaultYear"
                  :input-pre-filled="true"
                  date-format="%n %Y"
                  lang="fr"
                  style="width: 100% !important;"
                  @change="showDate">
                </month-picker-input>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :invalid-feedback="form.montant.invalidFeedback"
                :label="$t('treasury.montant.field')"
                :state="form.montant.state"
                class="medium-label mb-4"
                label-for="name-input">
                <b-input-group>
                  <b-form-input
                    id="name-input"
                    ref="input-number"
                    v-model="form.montant.value"
                    v-disable-scroll
                    :disabled="this.disabledMontant"
                    :state="form.montant.state"
                    min="0"
                    required
                    step="any"
                    type="number"
                    v-on:change="askConfirm=true">
                  </b-form-input>
                  <b-input-group-append>€</b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
          </div>

          <div v-if="currentIdTreasury" class="row">
            <div class="col-md-12">
              <b-icon icon="info-circle" variant="primary"></b-icon>
              {{ this.$t('treasury.edit.solde') }}
              <strong>{{ formatDate(this.form.date.value) }}</strong>
            </div>
          </div>

          <div v-if="treasuryId !== null" class="d-flex justify-content-end">

            <b-button v-if="!currentIdTreasury" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
            <b-button v-else type="submit" variant="primary">{{ $t('Modify') }}</b-button>
          </div>

          <div v-else class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Create') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import backArrow from "../../components/b122/BackArrow";
import api from "../../services/api";
import { MonthPickerInput } from 'vue-month-picker'

export default {
  name: "TreasuryCreateEdit",

  components: {
    backArrow,
    MonthPickerInput
  },

  data() {
    return {
      treasuries: [],
      treasuryId: this.$route.params.treasuryId,
      types: [],
      form: {
        montant:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        date:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      },
      currentIdTreasury: null,
      disabledMontant: true,
      askConfirm: false,
      defaultMonth: null,
      defaultYear: null
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {

    showDate(date) {
      let dateToFormat = new Date(date.from.getTime());
      let year = dateToFormat.getFullYear();
      let month = (dateToFormat.getMonth() + 1).toString().padStart(2, '0'); // Ajoute un 0 si nécessaire
      let day = dateToFormat.getDate().toString().padStart(2, '0'); // Ajoute un 0 si nécessaire
      this.form.date.value = `${year}-${month}-${day}`;
      this.handleTreasury();
    },


    handleTreasury() {
      if (this.treasuries.length > 0) {
        let index = this.treasuries.findIndex(it => {
          return it.date === this.form.date.value
        })
        if (index >= 0) {
          let treasury = this.treasuries[index]
          this.form.montant.value = treasury.solde
          this.form.date.value = treasury.date
          this.currentIdTreasury = treasury.id
        } else {
          this.form.montant.value = ''
          this.currentIdTreasury = null
        }
      }
      if(this.form.date.value && !this.form.date.value.includes("NaN")){
        this.disabledMontant = false
      }
    },

    formatDate(dateString) {
      const options = {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'};
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString('fr-FR', options);
      return formattedDate;
    },

    async fetchData() {
      await this.fetchAllTreasury()
      if (this.treasuryId) {
        await this.fetchTreasury()
      }
    },

    async fetchAllTreasury() {
      await api
        .get(`/treasury/getAll`)
        .then(response => {
          response.data.forEach(treasury => {
            let date = (new Date(treasury.date).toLocaleDateString()).split("/").reverse().join("-")
            this.treasuries.push({...treasury, date: date})
          })
        })
    },

    async fetchTreasury() {
      await api
        .get(`/treasury/${this.treasuryId}`)
        .then(response => {
          this.form.montant.value = response.data.solde
          this.form.date.value = (new Date(response.data.date).toLocaleDateString()).split("/").reverse().join("-")
          this.defaultYear = Number(this.form.date.value.split("-")[0])
          this.defaultMonth = Number(this.form.date.value.split("-")[1])
          this.currentIdTreasury = response.data.id
          this.disabledMontant = false
        })
    },

    async onSubmit() {
      let data = new FormData()
      data.append('montant', this.form.montant.value)
      data.append('date', this.form.date.value)

      let url = 'treasury'
      if (this.currentIdTreasury) {
        url = '/treasury/' + this.currentIdTreasury
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'TreasuryIndex'
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'TreasuryIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/treasury/TreasuryCreateEdit.vue